/* @flow */
import querystring from "querystring";

// Я хотел чтобы флаги оставались
// как можно статичнее, но реальность
// диктует иные правила, поэтому флаги
// теперь можно включать в рантайме.

function hydrateFlag(flag, defaultValue) {
  const hashFlags = querystring.parse(window.location.hash.slice(1));

  if (typeof hashFlags[flag] === "string") {
    return hashFlags[flag] === "true";
  }

  try {
    const stored = localStorage.getItem(`__superSecretUnstable_${flag}`);

    if (typeof stored === "string") {
      return stored === "true";
    } else {
      return defaultValue;
    }
  } catch (error) {
    return defaultValue;
  }
}

//const enableForSiam = process.env.REACT_APP_DEPLOY_TARGET === "siamoption";
const enableForIronAndEz =
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ||
  process.env.REACT_APP_DEPLOY_TARGET === "eztrader";

const disableForEz = process.env.REACT_APP_DEPLOY_TARGET !== "eztrader";

const flags = {
  useCoolPhoneInputOnAuth: enableForIronAndEz,
  useCoolPhoneInputOnProfile: enableForIronAndEz,
  useCoolPhoneInputOnVerification: enableForIronAndEz,
  enableBell: true,
  enableHelpdesk: true,
  enableHelpdeskNews: true,
  enableTournaments: disableForEz, //hydrateFlag("enableTournaments", enableForSiam)
  showHelpdeskNewsRoute: true,
  enableCitizenshipSelect: enableForIronAndEz,
  enableCurrencySelect: true,
  enableOptimisticDeals: false,
  enableBackgroundStockIndication: true,
  enableOneSignal: hydrateFlag("enableOneSignal", true),
  enableOneSignalInProfile:
    hydrateFlag("enableOneSignal", false) &&
    hydrateFlag("enableOneSignalInProfile", false),
  forceLongHistory: hydrateFlag("forceLongHistory", true),
  debugHistoryFrames: hydrateFlag("debugHistoryFrames", false),
  logSocket: hydrateFlag("logSocket", false),
  OperationCheque: true,
  enableNewFinalPopup: true,
  enableChat: true,
  enableTriggers: true,
};

window.magicallyEnableFeature = (flag) => {
  flags[flag] = true;
  localStorage.setItem(`__superSecretUnstable_${flag}`, "true");
};

export default flags;



// WEBPACK FOOTER //
// ./src/FeatureFlags.js